import { React, useState, useEffect } from "react";

import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { InsideDrawerNav } from "./InsideDrawerNav";

import { Routes, servicesRoutes } from "consts/Routes-App";

import { useRecoilValue } from "recoil";

import { services as servicesGlobalState } from "recoilState/GlobalState";



import styles from "./ListDrawer.module.scss";

import { ExpandLess, ExpandMore, HomeRounded, PeopleRounded } from "@mui/icons-material";

import { Link } from "react-router-dom";



import * as iconServicios from "assets/icons/servicios";



export default function ListDrawer({ setOpen }) {

    const [isDrawerOpen, setIsDrawerOpen] = useState({});



    const services = useRecoilValue(servicesGlobalState);



    const handleClick = () => {

        setOpen(false);

    };



    const authorizedServices = services.filter(

        (service) => service.servicioAutorizado === "Y"

    );



    useEffect(() => {

        const initialState = {};

        authorizedServices.forEach((service) => {

            initialState[service.servicioCod] = false;

        });

        setIsDrawerOpen(initialState);

    }, [services]);



    const renderServiceMenu = (servicioCod, servicioNombre) => (

        <span key={servicioCod}>

            <ListItemButton

                className={styles.itemList}

                onClick={() =>

                    setIsDrawerOpen({

                        ...isDrawerOpen,

                        [servicioCod]: !isDrawerOpen[servicioCod],

                    })

                }

            >

                <ListItemIcon>

                    <img

                        alt={servicioNombre}

                        className={styles.iconsDrawer}

                        src={iconServicios.LogoHotel}

                    />

                </ListItemIcon>

                <ListItemText

                    className={

                        isDrawerOpen[servicioCod]

                            ? styles.textColorSelect

                            : styles.textColor

                    }

                >

                    {servicioNombre}

                </ListItemText>

                {isDrawerOpen[servicioCod] ? (

                    <ExpandLess style={{ color: "#363683" }} />

                ) : (

                    <ExpandMore style={{ color: "#9c9db0" }} />

                )}

            </ListItemButton>

            <Collapse in={isDrawerOpen[servicioCod]} timeout="auto">

                <List component="div">

                    {servicesRoutes[servicioCod]?.map((menu, index) => (

                        <InsideDrawerNav

                            key={index}

                            menu={menu}

                            className={styles.link}

                            handleClick={handleClick}

                            route={`servicio/${servicioCod}`}

                        />

                    ))}

                </List>

            </Collapse>

        </span>

    );



    return (

        <List

            aria-labelledby="nested-list-subheader"

            className={styles.root}

            component="nav"

        >

            <Link to={Routes.dashboard.route}>

                <ListItem className={styles.itemList} onClick={handleClick}>

                    <ListItemIcon>

                        <HomeRounded className={styles.iconsDrawer} />

                    </ListItemIcon>

                    <span className={styles.textColor}>Home</span>

                </ListItem>

            </Link>



            {/* <Link to={Routes.usuarios.route}>

                <ListItem className={styles.itemList} onClick={handleClick}>

                    <ListItemIcon>

                        <PeopleRounded className={styles.iconsDrawer} />

                    </ListItemIcon>

                    <span className={styles.textColor}>Administrativos</span>

                </ListItem>

            </Link> */}



            {authorizedServices.map((service) =>

                renderServiceMenu(service.servicioCod, service.servicioNombre)

            )}


        </List>

    );

}

